// extracted by mini-css-extract-plugin
export default {"typingItem":"TypingIndicator_typingItem__RmfvN","container":"TypingIndicator_container__UdJuT","dot":"TypingIndicator_dot__i9tkE","zoom":"TypingIndicator_zoom__01kxA"};